import React, { useState, useEffect } from "react";
import "./Hero.css";

function Hero() {
  const images = [
    "/em4.png",
    "/em3.png",
    "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    "https://images.pexels.com/photos/1181347/pexels-photo-1181347.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % images.length
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: `url(${images[currentImageIndex]})`,
      }}
    >
      <div className="hero-overlay"></div>
      <div className="container position-relative text-white text-center">
        <h1 className="display-5 fw-bold">Welcome To Emkan</h1>
        <p className="lead mt-3">
          At Emkan, we think that the foundation of any successful company is
          sound bookkeeping and accounting. In addition to helping you stay in
          compliance with legal
        </p>

        {/* WhatsApp Button */}
        <a
          href="https://wa.me/971588124755"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          <i className="bi bi-whatsapp me-2"></i> Chat on WhatsApp
        </a>
      </div>
    </section>
  );
}

export default Hero;
